'use client';

import {
  IconCreditCardUp,
  IconFile02,
  IconSquareDashboard,
  InfoSection as KeziosInfoSection,
} from '@kezios/design-system';
import { SectionHeader, SectionLayout, Spacing } from '@kezios/design-system';
import { Stack } from '@mantine/core';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

export const DataSecurityPrivacyPage = () => {
  const t = useTranslations('page.data-security-privacy');

  return (
    <SectionLayout>
      <Stack pb={Spacing.s24}>
        <SectionHeader
          category={t('category')}
          title={t('title')}
          subtitle={t('subtitle')}
        />
        <KeziosInfoSection pt={Spacing.s24}>
          <KeziosInfoSection.Item
            title={t('infos.security.title')}
            description={
              <>
                {t.rich('infos.security.description', {
                  ul: chunk => <ul>{chunk}</ul>,
                  li: chunk => <li>{chunk}</li>,
                })}
              </>
            }
            icon={<IconFile02 />}
            image={
              <Image
                alt="tutorial"
                src={'/static/data-security-privacy/security.png'}
                fill
                style={{ objectFit: 'contain', padding: '48px' }}
              />
            }
            reverse={false}
          />
          <KeziosInfoSection.Item
            title={t('infos.privacy.title')}
            description={
              <>{t.rich('infos.privacy.description', { br: () => <br /> })}</>
            }
            icon={<IconSquareDashboard />}
            image={
              <Image
                alt="tutorial"
                src={'/static/data-security-privacy/privacy.png'}
                fill
                style={{ objectFit: 'contain', padding: '48px' }}
              />
            }
            reverse={true}
          />
          <KeziosInfoSection.Item
            title={t('infos.audio-usage.title')}
            description={t('infos.audio-usage.description')}
            icon={<IconCreditCardUp />}
            image={
              <Image
                alt="tutorial"
                src={'/static/data-security-privacy/audio-usage.png'}
                fill
                style={{ objectFit: 'contain', padding: '48px' }}
              />
            }
            reverse={false}
          />
        </KeziosInfoSection>
      </Stack>
    </SectionLayout>
  );
};
